import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Signature } from '@/types/signature';
import type { OrgOpSignableDecision } from '@mls-wallet/shared-types';

type CreateMemberSignatureArg = {
  proposalId: string;
  decision: OrgOpSignableDecision;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreateMemberSignatureArg }
): Promise<Signature[]> => {
  const { proposalId, decision } = arg;
  return await denApi.post<Signature[], { decision: OrgOpSignableDecision }>(
    `admin/organization/member-proposals/${encodeURIComponent(proposalId)}/signatures`,
    { decision }
  );
};

export function useMemberProposalSignature(
  swrOptions?: SWRMutationConfiguration<
    Signature[],
    Error,
    string,
    CreateMemberSignatureArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Signature[],
    Error,
    string,
    CreateMemberSignatureArg
  >('admin/organization/member-proposals/signature', fetcher, swrOptions);

  return { createSignature: trigger, isLoading: isMutating, error };
}
